export const REJECT_LOAD_OTHER_ID = 5;